import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationSupply from '@hook/parametrization/use-supply'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBar from '@component/Parameterization/Supply/SelectedTableBar'

import { disableActionsByDefault } from '@helper/parametrization/disableActionsByDefault'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const ParametrizationSupply: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    filename,
    params,
    handleLocalParams,
    filters,
    setFilters,
    handlePageChange,
    pagination,
    filtersList,
    fetching,
    query,
    tableInteraction,
    actions,
    getCenters,
    getData,
    setFilename,
    setQuery,
    clearAllFilters,
    handleUpdateParams
  } = useParametrizationSupply()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 187px)'
          : 'calc(100vh - 155px)'
        : hasSessions
        ? 'calc(100vh - 328px)'
        : 'calc(100vh - 296px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()
    handleLocalParams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCenters])

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          getFilters({
            companies: true,
            companiesConfig: true,
            worlds: true,
            centers: true,
            compactCategories: true,
            providersForPurchase: true,
            categoryManagers: true,
            productManagers: true,
            inventoryStatus: true,
            abcCurves: true,
            cluster: true,
            centerTypes: true,
            subCategories: true,
            qtd: 12
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Abastecimento">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <GridQuantity
                pagination={pagination}
                disabled={pagination.totalRows === 0}
              />

              <SelectedTableBar />

              <TableGrid
                id="supply-table"
                headers={headers}
                query={query}
                data={data}
                loading={fetching}
                itsSortable={true}
                actions={tableInteraction}
                height={tableHeight}
                entity={'parametrization-supply'}
                pagination={pagination}
                udatePageChange={handlePageChange}
                isPagedBack={true}
                isPaged={false}
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationSupply
